import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NguiScrollableModule } from '@ngui/scrollable';
import { scrollTo } from '@ngui/utils';
import { print } from 'util';
import { BudgetService } from '../service/budget.service';
import { CashFlowService } from '../service/cashflow.service';
import { CompanyService } from '../service/company.service';
import { LoanService } from '../service/loan.service';
import { OperatingexpensesService } from '../service/operatingexpenses.service';
import { ProjectService } from '../service/project.service';
import { ReportingService } from '../service/reporting.service';

@Component({
  selector: 'app-financialreports',
  templateUrl: './financialreports.component.html',
  styleUrls: ['./financialreports.component.css'],
})
export class FinancialreportsComponent implements OnInit {
  constructor(
    private cashflowservice: CashFlowService,
    private operatingexpensesService: OperatingexpensesService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private loanService: LoanService,
    private reportingService: ReportingService
  ) {
    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.investors = [];
    this.showInstructions = false;
    this.getCompanyData();
    this.getProjectData();
    this.totalCols = this.totalCols;
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Output() financingreportEmit: EventEmitter<any> = new EventEmitter();

  @Output() loanEmitFinancialReport: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  projectId = '';

  companyId = '';

  companyLogoUrl = '';

  projectName = '';

  maintenanceReserve = '';

  operatingCapital: Number;

  investorsTotal: Number;

  start_up_month: Number;

  maintenance_reserve = '';

  maintenanceReserveContribution = '';

  reportData = {
    data: {
      debtServiceArray: [],
      repairMaintenanceArray: [],
      opExArray: [],
      goiArray: [],
      additionalInvestment: [],
      accountOperatingAccount: [],
      accountMaintenanceReserve: [],
      investorArrays: [],
      acquisition_construction_renovation: [],
      investorShares: [],
      aggregateDebtOutstanding: [],
      cashGeneralReserve: [],
      land_building: [],
      finalInvestorNameShareArray: [],
      assetCalcArray: [],
      liabilitiesCalcArray: [],
      cummulativeCalcArray: [],
      surplusCalcArray: [],
      cashUnrestrictedArray: [],
      debtPayoffs: [],
      cashRepairReserve: [],
      debtsToAssetsRatio: [],
      debtServiceCoverageMultipleArray: [],
      investorSharesCumulative: [],
      equityArray: [],
      singleValuesArray: [],
      debtsTenToAssetsRatio: [],
      debtServiceTenCoverageMultipleArray: [],
      equityInvestmentArray: [],
    },
  };

  alphabets: any = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];

  numbers: any = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eigth', 'Nine', 'Ten'];

  public totalCols = Array(40)
    .fill(null)
    .map((x, i) => i);

  public tenCols = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40];

  public lineChartLabels = this.tenCols;

  public lineChartLegend = true;

  public lineChartType = 'line';

  public lineChartData1: any[] = [
    {
      data: '',
    },
  ];

  public lineChartData2: any[] = [
    {
      data: '',
    },
  ];

  public lineChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: {
      fontFamily: 'Roboto',
      position: 'top',
      labels: {
        fontStyle: 'bold',
        boxWidth: 10,
        fontSize: 15,
        padding: 30,
        fontColor: 'black',
        margin: 50,
      },
    },
    tooltips: {
      callbacks: {
        label(tooltipItem) {
          const val = tooltipItem.yLabel;
          return val.toFixed(3).slice(0, -1);
        },
        title(tooltipItem, data) {
          return `${tooltipItem[0].xLabel} Quarter`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontColor: 'black',
            fontSize: 14,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontFamily: 'Roboto',
            fontSize: 14,
            fontColor: 'black',
            fontStyle: 'bold',
          },
        },
      ],
    },
  };

  public lineChartColors1: any[] = [
    {
      backgroundColor: '#FFB3BA',
      borderColor: '#FFB3BA',
      pointBackgroundColor: '#FFB3BA',
      pointBorderColor: '#FFB3BA',
      pointHoverBackgroundColor: '#FFB3BA',
      pointHoverBorderColor: '#FFB3BA',
    },
  ];

  public lineChartColors2: any[] = [
    {
      backgroundColor: '#BAFFC9',
      borderColor: '#BAFFC9',
      pointBackgroundColor: '#BAFFC9',
      pointBorderColor: '#BAFFC9',
      pointHoverBackgroundColor: '#BAFFC9',
      pointHoverBorderColor: '#BAFFC9',
    },
  ];

  investors: string[] = new Array();

  investorsArray = [];

  showInstructions: boolean;

  // DECLARATION OF OBJECT TO SHOW TEN YEARS DATA IN PRINTING AS WELL AS IN SCRENN
  parentObject: any = {
    labels: new Array(),
    qtrs: new Array(10),
    months: new Array(),
    trs: new Array(),
    tables: new Array(1),
    investorArrays: new Array(),
    loanInvestorNamesArray: new Array(),
    investors: new Array(),
    surplusCalcArray: new Array(),
  };

  parentObject2: any = {
    labels: new Array(),
    qtrs: new Array(10),
    months: new Array(),
    trs: new Array(),
    tables: new Array(1),
    investorArrays: new Array(),
    loanInvestorNamesArray: new Array(),
    investors: new Array(),
    surplusCalcArray: new Array(),
  };

  // DECLARATION FOR FIXED TABLE SCROLLING
  id = 's1';

  hid = 'h1';

  wid = 'w1';

  scrollTo(selector, parentSelector, horizontal) {
    scrollTo(
      selector, // scroll to this
      parentSelector, // scroll within (null if window scrolling)
      horizontal, // is it horizontal scrolling
      0 // distance from top or left
    );
    this.hid = selector.split('#').join('');
  }

  ngOnInit() {
    this.parentObject.labels.push(
      'Acquisition / Construction / Renovation',
      'Debt Proceeds and Payoffs',
      'Equity Investment',
      'Gross Operating Income',
      'Operating Expenses',
      'Debt Service',
      'Operating Capital Contribution',
      'Maintenance Reserve Contribution',
      'Total Quarterly Cash Flow',
      'Equity Investor Distributions'
    );

    this.parentObject2.labels.push(
      'Cash: Unrestricted',
      'Cash : Operating Capital',
      'Cash : Maintenance Reserve',
      'Land, Building, Personal Depreciable Property'
    );
    if (this.print) {
      this.parentObject.tables = new Array(5);
    }
    this.parentObject.print = this.print;
  }

  // TO GET COMPANY LOGO DATA FROM DB THROUGH COMPANY SERVICE
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  // TO GET PROJECT NAME FROM PROJECT SERVICE FROM DB
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.maintenanceReserve = projectData.data[0].maintenance_reserve;
      this.operatingCapital = projectData.data[0].operating_capital;
      this.maintenanceReserveContribution = projectData.data[0].maintenance_reserve_contribution;
      this.start_up_month = projectData.data[0].start_up_month;
      this.maintenance_reserve = projectData.data[0].maintenance_reserve;

      // TO GET BUDGET DATA THROUGH BUDGET SERVICE FROM DB
      this.budgetService.getBudget(this.projectId).subscribe((budgetData) => {
        const acquisition_construction_renovation =
          budgetData.data[0].business_purchase_price +
          budgetData.data[0].total_realEstateSubTotal +
          budgetData.data[0].total_professionalSubTotal +
          budgetData.data[0].total_specialItemsSubTotal +
          budgetData.data[0].total_exteriorSubTotal +
          budgetData.data[0].total_interiorSubTotal;

        const data = {
          project_id: this.projectId,
          operatingCapital: this.operatingCapital,
          maintenanceReserve: this.maintenanceReserve,
          maintenanceReserveContribution: this.maintenanceReserveContribution,
          acquisition_construction_renovation,
          start_up_month: this.start_up_month,
          maintenance_reserve: this.maintenance_reserve,
        };

        // TO GET REPORTING DATA OF INERMATH CAL THROUGH REPORTING SERVICE FROM DB
        this.reportingService.fetchReportData(data).subscribe((res) => {
          const lineChartData1 = [];
          res.data.debtsTenToAssetsRatio.unshift(0);

          lineChartData1.push({
            data: res.data.debtsTenToAssetsRatio,
            label: 'DEBT TO ASSETS RATIO',
          });
          this.lineChartData1 = lineChartData1;

          const lineChartData2 = [];
          res.data.debtServiceTenCoverageMultipleArray.unshift(0);
          lineChartData2.push({
            data: res.data.debtServiceTenCoverageMultipleArray,
            label: 'DEBT SERVICE COVERAGE',
          });
          this.lineChartData2 = lineChartData2;

          this.reportData = res;
          this.investorsTotal = res.data.finalInvestorNameShareArray.length;

          // SET PARENT OBJECT TO SHOW DATA OF TABLES TO SHOW TEN YEARS DATA IN PRINTING AS WELL AS IN SCREEN
          this.parentObject.investorArrays = this.reportData.data.investorArrays;
          this.parentObject.loanInvestorNamesArray = res.data.loanInvestorNamesArray;

          const acquisitionArray = new Array();
          const equityInvestmentArray = new Array();
          const operatingCapitalArray = new Array();
          const maintenanceReserveArray = new Array();

          acquisitionArray[0] = res.data.singleValuesArray[0];
          for (let i = 1; i < 40; i++) {
            acquisitionArray.push(0);
          }

          equityInvestmentArray.push(res.data.singleValuesArray[2]);
          for (let i = 1; i < 40; i++) {
            equityInvestmentArray.push(0);
          }

          operatingCapitalArray.push(res.data.singleValuesArray[1]);
          for (let i = 1; i < 40; i++) {
            operatingCapitalArray.push(0);
          }

          maintenanceReserveArray[0] = res.data.singleValuesArray[3];
          for (let i = 1; i < res.data.repairMaintenanceArray.length; i++) {
            maintenanceReserveArray.push(res.data.repairMaintenanceArray[i]);
          }

          this.parentObject.trs.push(
            acquisitionArray,
            res.data.debtPayoffs,
            equityInvestmentArray,
            res.data.goiArray,
            res.data.opExArray,
            res.data.debtServiceArray,
            operatingCapitalArray,
            maintenanceReserveArray,
            res.data.cummulativeCalcArray
          );

          this.parentObject.investors = res.data.investorShares;
          this.parentObject.surplusCalcArray = res.data.surplusCalcArray;

          // Second Section Parent Object Intialization
          this.parentObject2.trs.push(
            res.data.cashUnrestrictedArray,
            res.data.cashGeneralReserve,
            res.data.cashRepairReserve,
            res.data.land_building,
            res.data.assetCalcArray
          );
          this.parentObject2.aggregateDebtOutstanding = res.data.aggregateDebtOutstanding;
          this.parentObject2.investors = res.data.finalInvestorNameShareArray;
          this.parentObject2.equityArray = res.data.equityArray;
          this.parentObject2.assetCalcArray = res.data.assetCalcArray;
        });
        // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
        this.financingreportEmit.emit({ financingreportEmit: true });
      });
    });
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/financialreports/financialreports.component.ts